import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Controls from './controls/Controls';

export default function GenerateFinancialStatementsInvoiceDialog({ open, handleClose, handleConfirm, year, isGenerating }) {

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="invoice-dialog-title"
            aria-describedby="invoice-dialog-description"
        >
            <DialogTitle id="invoice-dialog-title">
                {"Generowanie faktur za sprawozdania finansowe"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="invoice-dialog-description">
                    Czy potwierdzasz, że chcesz wygenerować faktury za sprawozdania finansowe za rok <strong>{year}</strong> dla zaznaczonych podmiotów?
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Controls.PremiumButton
                    variant="glass"
                    onClick={handleClose}
                    disabled={isGenerating}
                    label="Anuluj"
                />
                <Controls.PremiumButton
                    variant="green"
                    onClick={handleConfirm}
                    disabled={isGenerating}
                    icon={isGenerating ? "fas fa-spinner fa-spin" : "fas fa-file-invoice-dollar"}
                    label={isGenerating ? 'Generowanie...' : 'Generuj faktury'}
                />
            </DialogActions>
        </Dialog>
    );
}
